import React, { useEffect } from "react";
import { SeverityGroup } from "./SeverityGroup";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { editVariance } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";

function Severity(props: { canEdit: boolean }) {
  const dispatch = useAppDispatch();
  const incident = useAppSelector(state => state.varianceRequest.varianceRequest);
  
  // Check if this is a new incident based on timestamp
  const isNewIncident = React.useMemo(() => {
    const useLegacyCodes = incident.varianceStartDate && 
                          new Date(incident.varianceStartDate).getTime() < new Date('2025-07-17').getTime();
    return !useLegacyCodes;
  }, [incident.varianceStartDate]);
  
  useEffect(() => {
    if (isNewIncident && !incident.severity && props.canEdit) {
      dispatch(editVariance({ name: "severity", value: "NME3" }));
    }
  }, [isNewIncident, incident.severity, props.canEdit, dispatch]);

  // Legacy groups for old incidents
  const legacyGroups = [
    { value: "NO_ERROR", displayName: "No Error" },
    { value: "ERROR_INTERCEPTED", displayName: "Error Intercepted" },
    { value: "ERROR_NO_HARM", displayName: "Error with No Harm" },
    { value: "ERROR_HARM", displayName: "Error with Harm" },
    { value: "ERROR_DEATH", displayName: "Error with Death" }
  ];
  
  // New SEC grouping for new incidents
  const newGroups = [
    { value: "SSE", displayName: "Serious Safety Event (SSE)" },
    { value: "PSE", displayName: "Precursor Safety Event (PSE)" },
    { value: "NME", displayName: "Near Miss Safety Event (NME)" }
  ];

  const groupsToUse = isNewIncident ? newGroups : legacyGroups;
  
  return (
    <React.Fragment>
      {groupsToUse.map((item) => (
        <SeverityGroup 
          key={item.value} 
          canEdit={props.canEdit} 
          severityGroup={item} 
          isNewIncident={isNewIncident} 
        />
      ))}
    </React.Fragment>
  );
}

export {Severity};